module.exports = __webpack_public_path__ + "img/arrow.89db131e.png";